module.exports = __webpack_public_path__ + "static/velourteddy1-71bffc87defec1c8c8b58cf68d4ed2ed.jpeg";